import type { Resource } from '../../';
export const product_tiles_quickView_viewProductDetails: Resource = {"default":"View Full Product Details"};
